import { useState } from 'react';
import { IAssistantsList } from './useListAssistants';
import api from '@/services/api';
import { ModelData } from './useRegisterAssistant';

export const useEditAssistant = () => {
  const [assistant, setAssistant] = useState<IAssistantsList | null>(null);

  const editAssistant = async (id: string, data: ModelData) => {
    const response = await api.put(`/api/v1/assistants/${id}`, data);
    return response.data;
  };

  const updateFileDescription = async (assistantId: string, fileId: string, description: string) => {
    const response = await api.put(`/api/v1/assistants/${assistantId}/files/${fileId}/summary`, {
      summary: description,
    });
    return response.data;
  };
  const getFileDescription = async (assistantId: string, fileId: string) => {
    const response = await api.get(`/api/v1/assistants/${assistantId}/files/${fileId}`);
    return response.data;
  };

  const getAssistantFiles = async (assistantId: string) => {
    const response = await api.get(`/api/v1/assistants/${assistantId}/files`);
    return response.data;
  };

  return { assistant, getAssistantFiles, editAssistant, setAssistant, updateFileDescription, getFileDescription };
};
